import { Grid } from '@mui/material';
import React from 'react';
import AuthPartners from '../AuthPartners/AuthPartners';
import Partners from '../Partners/Partners';

const PartnerSettings = () => (
	<Grid container spacing={3}>
		<Grid size={{ xs: 12 }}>
			<Partners />
		</Grid>
		<Grid size={{ xs: 12 }}>
			<AuthPartners />
		</Grid>
	</Grid>
);

export default PartnerSettings;
